import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { withQueryClientContext } from '../../../../app/shared/components/QueryClientContext'
import { AllocationsOverTime } from '../components/AllocationsOverTime'
import { ConfidentialWarning } from '../components/ConfidentialWarning'
import { DetailsSummary } from '../components/DetailsSummary'
import { HoldingsHeatmap } from '../components/HoldingsHeatmap'
import { ManagerDetailsLayout } from '../components/ManagerDetailsLayout'
import { ManagerHeading } from '../components/ManagerHeading'
import { InitialManagerDetailsData, InsiderView } from '../constants'
import { useInsiderTradingRouter } from '../hooks/useInsiderTradingRouter'
import { useManagerDetailsData } from '../hooks/useManagerDetailsData'

function ManagerDetails() {
  const initialData = useLoaderData() as InitialManagerDetailsData | null
  const insiderTradingRouter = useInsiderTradingRouter<InsiderView.ManagerDetails>()
  const managerDetailsData = useManagerDetailsData({
    id: insiderTradingRouter.viewParams.investorId,
    initialData: initialData?.initialManagerDetailsData,
  })
  const managerDetails = managerDetailsData.data!

  // useRef is needed to cache certain data which comes from initialData and is not available after initial rerenders
  const { current: reportEndDates } = React.useRef(initialData?.initialManagerReportDates ?? [])

  return (
    <ManagerDetailsLayout reportEndDates={reportEndDates}>
      <div>
        <ManagerHeading filer={managerDetails.filer} />
        {managerDetails.latestSummary.isConfidentialOmitted && <ConfidentialWarning />}
      </div>
      <div className="grid grid-cols-2 gap-6">
        <AllocationsOverTime
          headingLabel="Sector Allocation Over Time"
          sectorAllocations={managerDetails.sectorAllocations}
        />

        <div className="grid grid-cols-1 gap-6">
          <HoldingsHeatmap data={managerDetails.mapData} />

          <DetailsSummary
            latestSummary={managerDetails.latestSummary}
            individualManagers={managerDetails.individualManagers}
            topBuysPct={managerDetails.topBuysPct}
            topBuysUsd={managerDetails.topBuysUsd}
            topSellsPct={managerDetails.topSellsPct}
            topSellsUsd={managerDetails.topSellsUsd}
          />
        </div>
      </div>
    </ManagerDetailsLayout>
  )
}

export default withQueryClientContext(ManagerDetails)
